export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-3.png?f59b0de41bc6aeccba1217c1a572b233";